import { useEffect } from 'react';

type DoubleClickHandler = (event: MouseEvent) => void;

function useDoubleClick(onDoubleClick: DoubleClickHandler) {
  useEffect(() => {
    const handleDoubleClick = (event: MouseEvent) => {
      event.stopPropagation();
      onDoubleClick(event);
    };

    document.addEventListener('dblclick', handleDoubleClick);

    return () => {
      document.removeEventListener('dblclick', handleDoubleClick);
    };
  }, [onDoubleClick]);
}

export default useDoubleClick;